module.exports = __webpack_public_path__ + "img/qbc-pricing@2x.b4c0c924.png";